import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO } from "./assets";
import { useLang } from "./LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const LINKS = [
  { key: "systems", href: "#features" },
  { key: "genres", href: "#genres" },
  { key: "world", href: "#world" },
  { key: "arenas", href: "#media" },
];

export const Navbar = () => {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "glass border-b border-[#00F2FE]/15" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo" className="flex items-center flicker">
          <img src={LOGO} alt="Ino Elites" className="h-9 md:h-11 w-auto drop-shadow-[0_0_14px_rgba(0,242,254,0.55)]" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`navlink-${l.key}`}
              className="text-xs font-semibold tracking-[0.25em] text-slate-300 hover:text-[#00F2FE] transition-colors"
            >
              {t(`nav.${l.key}`)}
            </a>
          ))}
          <LanguageSwitcher />
          <a
            href="#newsletter"
            data-testid="navbar-wishlist-button"
            className="bg-[#00F2FE] text-[#060A14] text-xs font-bold uppercase tracking-widest px-6 py-2.5 rounded-sm hover:bg-white shadow-[0_0_22px_rgba(0,242,254,0.45)] transition-all duration-300"
          >
            {t("nav.wishlist")}
          </a>
        </nav>

        <button
          data-testid="navbar-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="navbar-mobile-menu" className="md:hidden glass border-b border-[#00F2FE]/15 px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`navlink-mobile-${l.key}`}
              onClick={() => setOpen(false)}
              className="text-sm font-semibold tracking-[0.25em] text-slate-200 hover:text-[#00F2FE]"
            >
              {t(`nav.${l.key}`)}
            </a>
          ))}
          <div className="border-t border-white/10 pt-3"><LanguageSwitcher full /></div>
          <a
            href="#newsletter"
            data-testid="navbar-mobile-wishlist-button"
            onClick={() => setOpen(false)}
            className="bg-[#00F2FE] text-[#060A14] text-sm font-bold uppercase tracking-widest px-5 py-3 rounded-sm text-center"
          >
            {t("nav.wishlist")}
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
